import styled from 'styled-components';
import { white, gray10, screenSmMin, spacer24, spacer4, screenXsMax } from '@spotify-internal/encore-foundation';

var isDarkTheme = function isDarkTheme(props) {
  return props.theme.app === 'dark';
};

export default styled.li.withConfig({
  displayName: "Item",
  componentId: "sc-1l3x81u-0"
})(["color:", ";@media (max-width:", "){padding-bottom:", ";padding-top:", ";&:last-child{padding-bottom:0;}}@media (min-width:", "){padding-left:", ";padding-right:", ";&:first-child{padding-left:0;}&:last-child{flex:1;padding-right:0;}}"], function (props) {
  return isDarkTheme(props) ? white : gray10;
}, screenXsMax, spacer4, spacer4, screenSmMin, spacer24, spacer24);